module.exports = __webpack_public_path__ + "static/step-1-24ea8d0f26e2c5cbaa6c8e94a475683b.svg";